<template>
  <v-container>
    <v-card>
      <v-card-title>
{{ $t('learner.get-started') }}
      <v-spacer />
      <v-btn color="blue" @click="showShortcodeGenerator">
{{ $t('welcome.get-access-code') }}
</v-btn>
      </v-card-title>
      <v-card-text>
        <h3>{{ $t('learner.welcome-title', [userFirstName]) }}</h3><br>
        <div class="twocolumns">
        <p>{{ $t('welcome.accces-instructions') }}</p>
        <p v-if="isStreamingEnabled">
{{ $t('welcome.stream-instructions') }}
</p>
        <p>{{ $t('welcome.play-links') }}</p>
        <p>{{ $t('welcome.access-code') }}</p>
        </div>
      </v-card-text>
    </v-card>
    <v-row justify="center">
      <v-dialog v-model="showGenerator" max-width="500px">
        <shortcode-generator ref="generator" action="userLogin" :title="$t('welcome.generate-access-code')" no-button>
          <p>{{ $t('welcome.generator-instructions1') }}</p>
          <p>{{ $t('welcome.generator.instructions2') }} <a href="#" @click="refreshCode()">{{ $t('launch.step3.here') }}</a> </p>
        </shortcode-generator>
      </v-dialog>
    </v-row> 
  </v-container>
</template>

<script>

  import shortcodeGenerator from './ShortcodeGenerator.vue'


  export default {
    name: 'Home',

    components: {
      'shortcode-generator': shortcodeGenerator,
    },

    data () {
      return {
        showGenerator: false,
      }
    },

    computed: {
      userFirstName () {
        return this.$store.getters.currentUserProfile.user.displayName.split(' ')[0]
      },
      isStreamingEnabled () {
        return this.$store.getters.currentUserProfile.account.streamingEnabled
      },
    },

    methods: {
      showShortcodeGenerator () {
        this.showGenerator = true
        this.$nextTick(() => this.$refs.generator.generateShortcode())
      },
      refreshCode () {
        this.$refs.generator.generateShortcode()
      },
    },
  }

</script>

<style scoped>
.twocolumns {
  column-count: 2;
}

</style>
